/**
 * entryOverlapsReservation — shared queue/reservation window-overlap check.
 *
 * Byte-for-byte identical logic previously duplicated in
 * `use-reservation-queue-panel.ts` (global reservations list) and
 * `routes/media-units/$id/index.tsx` (unit detail panel) — both correlate a
 * QueueEntry to a reservation row by date-window overlap. Centralised here so
 * a future boundary-semantics change can't make the two surfaces disagree
 * (CU-86cb7ctfw review fix, DRY).
 */
import type { QueueEntry } from '@ooh/contracts';

/** Returns true when the queue entry's window overlaps the reservation's window. */
export function entryOverlapsReservation(
  entry: QueueEntry,
  res: { dateFrom: string; dateTo: string },
): boolean {
  return entry.dateFrom <= res.dateTo && entry.dateTo >= res.dateFrom;
}
